import { IApplicationState } from '../../types/redux';

export function getAuthor(state: IApplicationState) {
  return state.author;
}
